var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"mx-auto",attrs:{"eager":"","width":"180","height":"180","src":require('/public/assets/ilustration/no-data.svg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }